import { LogLevelEnum } from '@algolia/logger-common';
import { createConsoleLogger } from '@algolia/logger-console';
import algoliasearch from 'algoliasearch/lite';

interface IClientOpts {
  // biome-ignore lint/suspicious/noExplicitAny: can probably use types from algolia
  logger: any;
  // biome-ignore lint/suspicious/noExplicitAny: can probably use types from algolia
  hosts?: any;
}

export function NewSearchClient() {
  const opts: IClientOpts = {
    logger: createConsoleLogger(LogLevelEnum.INFO),
  };

  const host = process.env.NEXT_PUBLIC_SEARCH_PROXY;
  if (host) {
    opts.hosts = [
      {
        url: host,
        accept: 1,
        protocol: host.match(/localhost/) ? 'http' : 'https',
      },
    ];
  }

  return algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID as string,
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY as string,
    opts,
  );
}

export enum IndexName {
  Resources = 'resources',
  ResourcesDesc = 'resources.created_at_desc',
  Topics = 'topics',
  Categories = 'categories',
}

export const INDEX_NAMES = {
  resources: 'firestore.resources',
  resourcesDesc: 'firestore.resources.created_at_desc',
  topics: 'firestore.topics',
  categories: 'firestore.categories',
};

export const client = NewSearchClient();
export const indexes = {
  resources: client.initIndex(INDEX_NAMES.resources),
  resourcesDesc: client.initIndex(INDEX_NAMES.resourcesDesc),
  topics: client.initIndex(INDEX_NAMES.topics),
  categories: client.initIndex(INDEX_NAMES.categories),
};

export interface SearchOptions {
  first?: number;
  after?: string;
}

// biome-ignore lint/suspicious/noExplicitAny: type tied to algolia "hits" currently
export interface SearchResponse<T = Record<string, any>> {
  hits: T[];
  nbHits: number;
}

// biome-ignore lint/suspicious/noExplicitAny: type tied to algolia "hits" currently
export async function search<T = Record<string, any>>(
  indexName: IndexName,
  query: string,
  options: SearchOptions = {},
): Promise<SearchResponse<T>> {
  const { first = 10, after } = options;
  const index = client.initIndex(`firestore.${indexName}`);

  let offset = 0;
  if (after) {
    // We'll use the cursor decoding in GraphQL
    // This allows the search function to be used outside GraphQL if needed
    try {
      const decoded = JSON.parse(
        Buffer.from(after, 'base64').toString('utf-8'),
      );
      if (typeof decoded.offset === 'number') {
        offset = decoded.offset;
      }
    } catch (error) {
      console.error('Error parsing search cursor:', error);
    }
  }

  return index.search(query, {
    offset,
    length: first,
  });
}
